import { Injectable } from '@angular/core';
import { DatabaseService } from 'app/services/database/database.service';
import { Logger } from 'app/shared/logger';
import { LoggerFactory } from 'app/shared/loggerFactory';

@Injectable()
export class ConfigService {
    private logger: Logger;

    constructor(private database: DatabaseService, loggerFactory: LoggerFactory) {
        this.logger = loggerFactory.create('ConfigService');
    }

    public async get<T>(key: string, defaultValue?: T): Promise<T> {
        try {
            let value = await this.database.get<T>('configs', key);

            if (value === undefined || value === null) {
                return this.returnDefaultValue(key, defaultValue);
            }

            return value;
        } catch (e) {
            this.logger.error(`An error occured while getting configs with key '${key}'.`, e);
            return this.returnDefaultValue(key, defaultValue);
        }
    }

    private returnDefaultValue<T>(key: string, defaultValue?: T) {
        if (defaultValue) {
            this.logger.debug(`Config key '${key}' was not found. Using default value ${defaultValue}.`);
            return defaultValue;
        }

        this.logger.warn(`Config key '${key}' was not found. Returning undefined.`);
        return undefined;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/config.service.ts